import { render, staticRenderFns } from "./waiting-room.vue?vue&type=template&id=5012b824&scoped=true"
import script from "./waiting-room.vue?vue&type=script&lang=js"
export * from "./waiting-room.vue?vue&type=script&lang=js"
import style0 from "./waiting-room.vue?vue&type=style&index=0&id=5012b824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5012b824",
  null
  
)

export default component.exports